import { useParticipantProperty } from "@daily-co/daily-react"

/** "Ada is sharing their screen": the sharer's Daily name, so everyone can tell whose screen is up. */
export function useScreenSharerLabel(sessionId: string, local: boolean) {
  const userName = useParticipantProperty(sessionId, "user_name") as string | undefined
  if (local) return "You are sharing your screen"
  return `${userName?.trim() || "Guest"} is sharing their screen`
}
